import { render, staticRenderFns } from "./MasterGroupClassHistory.vue?vue&type=template&id=a1338c8e"
import script from "./MasterGroupClassHistory.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports